import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import PropTypes from 'prop-types';

const languageOptions = ["Arabic", "Burmese", "Cantonese", "English", "French", "German", "Hindi","Indonesian", "Japanese", "Javanese", "Khmer", "Korean", "Kurdish", "Malay", "Mandarin Chinese", "Mon", "Punjabi", "Spanish", "Tagalog", "Urdu", "Vietnamese"]


/*
const schema = Yup.object().shape({
  languages: Yup.array()
    .min(1, 'Select at least one language')
    .required('Languages are required'),
});
*/
import { useTranslation } from 'react-i18next';

export default function LanguageTagForm({methods}) {
  const { t } = useTranslation();
  const {

    setValue,
    getValues,
    register,
    formState: { errors },
  } = methods 

  const [selectedLanguages, setSelectedLanguages] = useState(getValues("languages") ? getValues("languages") : []);

  const handleAddLanguage = (e) => {
    const value = e.target.value;
    if (value && !selectedLanguages.includes(value)) {
      const updated = [...selectedLanguages, value];
      setSelectedLanguages(updated);
      setValue('languages', updated);
    }
    e.target.value = ''; // Reset select
  };

  const handleRemove = (lang) => {
    const updated = selectedLanguages.filter((l) => l !== lang);
    setSelectedLanguages(updated);
    setValue('languages', updated);
  };



  return (
  
        <div className="mb-3">
          <label className="form-label">{t("Language abilities (spoken) , Please specify")}</label>
          <select className="form-select"  onChange={handleAddLanguage}>
            <option value="">{t("-- List of spoken languages --")}</option>
            {languageOptions.map((lang) => (
              <option key={lang} value={lang}>
                {lang}
              </option>
            ))}
          </select>
          <div className="mt-2">
            {selectedLanguages.map((lang) => (
              <span
                key={lang}
                className="badge bg-primary me-2 mb-2"
                style={{ cursor: 'pointer' }}
                onClick={() => handleRemove(lang)}
              >
                {lang} &times;
              </span>
            ))}
          </div>
          <div className="text-danger mt-1">{errors.languages?.message}</div>
        </div>

  
  );
}
LanguageTagForm.propTypes = {
    methods: PropTypes.shape({
        register: PropTypes.func.isRequired,
        getValues: PropTypes.func,
        setValue: PropTypes.func.isRequired,
        formState: PropTypes.shape({
            errors: PropTypes.object.isRequired
        }).isRequired
    }).isRequired,


}